import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import './CustomRRLink.scss';
// RR stands from React Router
const CustomRRLink = ({ to, text, className }) => {
  const customRRLinkClasses = classNames({
    'custom-r-r-link': true,
    [`${className}`]: true,
  });
  return (
    <Link to={to} className={customRRLinkClasses}>
      {text}
    </Link>
  );
};

CustomRRLink.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};
CustomRRLink.defaultProps = {
  className: '',
};
export default CustomRRLink;



// WEBPACK FOOTER //
// ./src/components/_atomic/CustomRRLink/CustomRRLink.js